"use client";

import { getCookie, getPageName, getSiteProps, loadScript } from "@/utils";
import { prepareLeftFooterData, prepareRightFooterData } from "@/utils/footer";
import { getZunoScript } from "@/utils/zuno";
import {
  Button,
  Footer,
  RightArrow,
  WarningExclamation,
} from "@monsterindia/global-ui-components";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import FooterSkeleton from "./FooterSkeleton";
import { getFooterData } from "./query";
import { FooterProps } from "./types";

const FooterComponent: React.FC<FooterProps> = ({
  host,
  isLoggedIn,
  isMobile,
}) => {
  const { data, isLoading, isError } = getFooterData();
  const siteProps = getSiteProps(host);
  const [clientName, setClientName] = useState("");
  const pathName = usePathname();
  const pageName = getPageName(pathName);

  useEffect(() => {
    const cName = getCookie("client_name") || "";
    setClientName(cName);
    if (cName === "zuno") {
      const headerScript = getZunoScript("footer");
      loadScript(headerScript);
    }
  }, []);

  if (isLoading) return <FooterSkeleton />;
  if (isError) return <div>Error loading data. Please try again later.</div>;

  const bewareOfScammer = (
    <div className="flex w-full flex-row items-center justify-between gap-2 bg-[#FFF6E5] px-4 py-2 md:flex-row md:justify-center md:px-[120px] md:py-4">
      <div className="flex flex-col gap-[2px] md:flex-row md:gap-2">
        <div className="flex items-center gap-1 md:gap-2">
          <div className="relative bottom-[1px]">
            <WarningExclamation
              width={isMobile ? 14 : 22}
              height={isMobile ? 13 : 20}
            ></WarningExclamation>
          </div>
          <p className="text-[#17142A)] text-sm font-bold leading-5">
            Beware of Scammers
          </p>
        </div>
        <p className="text-sm font-normal leading-5 text-[#17142A]">
          We don’t charge money for job offers
        </p>
      </div>
      <Button
        label={
          <>
            <span className="text-xs font-semibold leading-4 text-[#6E00BE]">
              Know More
            </span>{" "}
            <RightArrow width={16} height={16} fill="#6E00BE" />
          </>
        }
        modifier="subtle-tertiary"
        size="md"
        url="/info/beware-of-fraudsters"
        className="hover:!bg-[#FFF6E5]"
      />
    </div>
  );

  return (
    <div
      className={`mb-[54px] md:mb-0 ${isLoggedIn && pageName === "Home" ? "custom-cursor" : ""}`}
      id="seekerFooter"
    >
      {pageName === "Job Details" && clientName === "zuno" ? (
        <div id="zuno-header">
          {/* @ts-expect-error: This custom element is not recognized by TypeScript */}
          <footer-zuno></footer-zuno>
        </div>
      ) : (
        <>
          {pathName === "/profile-performance" ? bewareOfScammer : null}
          <Footer
            rightFooterData={prepareRightFooterData(
              data?.MODULE_RIGHT_FOOTER_REACT_CORE || [],
              host,
            )}
            leftFooterData={prepareLeftFooterData(
              data?.MODULE_LEFT_FOOTER_REACT_CORE || [],
            )}
            showBanner={false}
            isLoggedIn={isLoggedIn}
            channelName={siteProps?.region}
            // getEventdata={(data: EventTrackingDataType) => {
            //   cleverTapAndMixPanelEvents.track(data.eventName, {
            //     ...data.ctProp,
            //   });
            // }}
          />
        </>
      )}
    </div>
  );
};

export default FooterComponent;
